import {Box, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, Typography, useTheme} from "@mui/material";
import QRCode from "react-qr-code";
import React from "react";
import { CloseRounded } from "@mui/icons-material";

const QrCodeDialog =  (props: any) => {
    const { onClose = null, backdropClick=true, size=256, dialogTitle='Title', spinner=false, viewQrCodeString=true, open, qrCode } = props;

    const theme = useTheme();

    const handleClose = (event: React.SyntheticEvent, reason: string) => {
        event.stopPropagation();

        if (reason === 'backdropClick' && backdropClick) {
            return;
        }

        if (!!onClose) {
            onClose();
        }
    };

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <Typography variant={"inherit"}>
                    {dialogTitle}
                </Typography>

                {
                    spinner &&
                    <CircularProgress size={24} sx={{mx: theme.spacing(1)}}/>
                }

                {
                    onClose &&
                    <IconButton aria-label="close" onClick={(e: React.SyntheticEvent) => handleClose(e, 'closeIco')}>
                        <CloseRounded />
                    </IconButton>
                }
            </DialogTitle>

            <DialogContent>
                {
                    <QRCode
                        size={size}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={qrCode}
                        viewBox={`0 0 128 128`}
                    />
                }

                {
                    viewQrCodeString &&
                    <Box sx={{my: theme.spacing(2)}}>
                        <Typography variant={"bodySmall"}>
                            <strong>
                                {qrCode}
                            </strong>
                        </Typography>
                    </Box>
                }
            </DialogContent>
        </Dialog>
    );
}

export default QrCodeDialog;